import { render } from "./registration-renewal-dialog.vue?vue&type=template&id=fca4c36c&scoped=true&ts=true"
import script from "./registration-renewal-dialog.vue?vue&type=script&lang=ts"
export * from "./registration-renewal-dialog.vue?vue&type=script&lang=ts"

import "./registration-renewal-dialog.vue?vue&type=style&index=0&id=fca4c36c&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca4c36c"]])

export default __exports__